import * as React from "react";

export const ArrowPointerIcon = () => (
  <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1.725V13.3125C0 13.6938 0.309375 14 0.6875 14C0.884375 14 1.075 13.9156 1.20625 13.7656L3.7875 10.8125L5.60313 14.4469C5.85 14.9406 6.45 15.1406 6.94375 14.8938C7.4375 14.6469 7.6375 14.0469 7.39062 13.5531L5.61875 10H9.30937C9.69063 10 10 9.69063 10 9.30937C10 9.1125 9.91563 8.925 9.76875 8.79375L1.20625 1.18438C1.07187 1.06563 0.903125 1 0.725 1C0.325 1 0 1.325 0 1.725Z" fill="#66717C"/>
  </svg>
);
